import { get, put } from '../../utils/http';

export const fetchPayRates = (accountId) => get(`/accounts/${accountId}/payrates`);

export const syncPayRates = (accountId, payrates) => put(`/accounts/${accountId}/payrates`, payrates);
